export default (_ctx, inject) => {
  const SEL = '[id^="___ratingbadge_"] iframe, #google-rating-badge iframe'

  const isVisible = el => {
    if (!el) return false
    const cs = getComputedStyle(el)
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false
    const r = el.getBoundingClientRect()
    return r.width > 0 && r.height > 0
  }

  const detect = () => {
    const el = document.querySelector(SEL)
    return !!el && isVisible(el)
  }

  /**
   * Watch for badge presence changes.
   * @param {(hasBadge:boolean)=>void} onChange
   * @param {{immediate?:boolean, timeout?:number}} opts
   * @returns {() => void} stop function
   */
  function watchGcrBadge(onChange, { immediate = true, timeout = 0 } = {}) {
    let last = detect()
    let stopped = false

    const emit = () => {
      const cur = detect()
      if (cur !== last) {
        last = cur
        onChange(cur)
        // also broadcast (other code can listen window event)
        window.dispatchEvent(new CustomEvent('gcr:badge-change', { detail: { hasBadge: cur } }))
      }
    }

    if (immediate) onChange(last)

    // Observe DOM mutations (badge injects/removes iframes)
    const mo = new MutationObserver(emit)
    try {
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] })
    } catch {}

    // Safety polling to catch edge cases (consent, late scripts)
    const start = Date.now()
    const poll = setInterval(() => {
      emit()
      if (timeout && Date.now() - start > timeout) clearInterval(poll)
    }, 300)

    // Re-check on load/resize
    const onLoad = () => emit()
    const onResize = () => emit()
    window.addEventListener('load', onLoad, { passive: true })
    window.addEventListener('resize', onResize, { passive: true })

    // Stop function
    return () => {
      if (stopped) return
      stopped = true
      try {
        mo.disconnect()
      } catch {}
      clearInterval(poll)
      window.removeEventListener('load', onLoad)
      window.removeEventListener('resize', onResize)
    }
  }

  // expose two helpers
  inject('gcr', {
    hasBadgeSync: () => detect(),
    watch: watchGcrBadge
  })
}
